(function ($) {
	$('.js-share:not(.share-email)').on('click', function (e) {
		e.preventDefault();

		if ($(this).hasClass('share-linkedin')) {
			popup($(this).attr('href'), 'Telavox', 650, 575);
		} else {
			popup($(this).attr('href'), 'Telavox', 650, 450);
		}
	});

	// @ts-ignore-next
	function popup(url, title, popup_width, popup_height) {
		var dual_screen_left =
			// @ts-ignore-next
			window.screenLeft != undefined ? window.screenLeft : screen.left;
		var dual_screen_top =
			// @ts-ignore-next
			window.screenTop != undefined ? window.screenTop : screen.top;
		var width = window.innerWidth
			? window.innerWidth
			: document.documentElement.clientWidth
			? document.documentElement.clientWidth
			: screen.width;
		var height = window.innerHeight
			? window.innerHeight
			: document.documentElement.clientHeight
			? document.documentElement.clientHeight
			: screen.height;
		var left = width / 2 - popup_width / 2 + dual_screen_left;
		var top = height / 2 - popup_height / 2 + dual_screen_top;
		var new_window = window.open(
			url,
			title,
			'toolbar=no,status=no,scrollbars=yes,width=' +
				popup_width +
				',height=' +
				popup_height +
				',top=' +
				top +
				',left=' +
				left
		);

		// @ts-ignore-next
		if (window.focus) {
			// @ts-ignore-next
			new_window.focus();
		}
	}
})(jQuery);
